class Multistore {

  constructor() {
  }

  init() {
    this.bindEvents();
    this.checkVariantAvailability();
  }

  bindEvents() {
    let _this = this;

    if (document.querySelector("input.Form__Input.custom-field")) {
      document.querySelectorAll("input.Form__Input.custom-field").forEach(function (el) {
        el.addEventListener("keyup", (e) => {
          let field = e.target;
          if (field.classList.contains('required') && field.value.length < 1) {
            field.closest('.field-container').classList.add('error');
          } else if (field.classList.contains('required') && field.classList.contains('select') && field.value == '0') {
            field.closest('.field-container').classList.add('error');
          } else {
            field.classList.remove('error');
            field.closest('.field-container').classList.remove('error');
          }
        });
      });

    }

    if (document.querySelector("#custom-cart-fields .field-container input")) {
      document.querySelectorAll("#custom-cart-fields .field-container input").forEach(function (el) {
        el.addEventListener("keyup", (e) => {
          let field = e.target;
          if (field.classList.contains('required') && field.value.length < 1) {
            field.closest('.field-container').classList.add('error');
          } else if (field.classList.contains('required') && field.classList.contains('select') && field.value == '0') {
            field.closest('.field-container').classList.add('error');
          } else {
            field.classList.remove('error');
            field.closest('.field-container').classList.remove('error');
          }
        });
      });

    }

    if (document.querySelector("select.Form__Input.custom-field")) {
      document.querySelectorAll("select.Form__Input.custom-field").forEach(function (el) {
        el.addEventListener("change", (e) => {
          let field = e.target;
          if (field.classList.contains('required') && field.value.length < 1) {
            field.closest('.field-container').classList.add('error');
          } else if (field.classList.contains('required') && field.classList.contains('select') && field.value == '0') {
            field.closest('.field-container').classList.add('error');
          } else {
            field.classList.remove('error');
            field.closest('.field-container').classList.remove('error');
          }
        });
      });

    }

    if (document.querySelector(".product-purchase-form button[type=\"submit\"]")) {
      document.querySelectorAll(".product-purchase-form button[type=\"submit\"]").forEach(function (el) {
        el.addEventListener("click", (e) => {
          let valid = _this.validateProductForm(e.target);
          if (!valid) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        });
      });
    }

    if (document.querySelector(".cart-form button[type=\"submit\"]")) {
      document.querySelectorAll(".cart-form button[type=\"submit\"]").forEach(function (el) {
        el.addEventListener("click", (e) => {
          let valid = _this.validateCartForm(el);
          if (!valid) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        });
      });
    }

    if (document.querySelector('.product-purchase-form [name="id"]') != null) {
      document.querySelector('.product-purchase-form [name="id"]').addEventListener("change", (e) => {
        setTimeout(function () {
          _this.updateGiftCardElements(e.target.value);
        }, 50)
      });
    }


    document.addEventListener('swatch-clicked', (e) => {
      // Add a small delay to make sure all events were dispatched and all elements were updated
      setTimeout(() => {
        _this.updateVariantSpecialNotice(e.detail.target.value);
      }, 50);
    });

    if (document.querySelector('.product-purchase-form [name="id"]')) {
      document.querySelector('.product-purchase-form [name="id"]').addEventListener("change", (e) => {
        _this.checkVariantAvailability();
      });
    }

    if (document.querySelector('[name="store-selector"]')) {
      document.querySelector('[name="store-selector"]').addEventListener("change", (e) => {
        _this.handleStoreSelectorChange(e.target.options[e.target.selectedIndex].dataset.childStoreId);
      });
    }
  }

  validateProductForm(btn) {
    let form = btn.closest('form');

    let valid = true;

    if (form.querySelector('.custom-field')) {
      let i = 1;
      form.querySelectorAll('.custom-field:not([disabled])').forEach(function (field) {
        let personalized = false;
        if (field.value.length > 1 && !field.closest('.gift-card-field')) personalized = true;
        if (field.classList.contains('required') && field.value.length < 1) {
          valid = false;
          field.closest('.field-container').classList.add('error');
        } else if (field.classList.contains('required') && field.classList.contains('select') && field.value == '0') {
          valid = false;
          field.closest('.field-container').classList.add('error');
        } else {
          field.classList.remove('error');
          field.closest('.field-container').classList.remove('error');
        }

        if (personalized) {
          if (form.querySelector('input[name="properties[_personalized_' + i + ']"]') == null) {
            let input = document.createElement("input");
            input.setAttribute('type', 'hidden');
            input.setAttribute('name', 'properties[_personalized_' + i + ']');
            input.setAttribute('value', 'true');
            form.appendChild(input);
          } else {
            form.querySelector('input[name="properties[_personalized_' + i + ']"]').value = 'true';
          }
        }
        i++;
      });
    }

    return valid;
  }

  validateCartForm(btn) {
    let form = btn.closest('form');
    let valid = true;

    if (form.querySelectorAll('select.required').length > 0) {
      form.querySelectorAll('select.required').forEach(function (field) {
        if (field.value == '') {
          valid = false;
          field.closest('.field-container').classList.add('error');
        } else {
          field.closest('.field-container').classList.remove('error');
        }
      });
    }

    if (form.querySelectorAll('input[required]').length > 0) {
      form.querySelectorAll('input[required]').forEach(function (field) {
        if (field.value == '') {
          valid = false;
          field.closest('.field-container').classList.add('error');
        } else {
          field.closest('.field-container').classList.remove('error');
        }
      });
    }
    return valid;
  }

  updateGiftCardElements(id) {
    let variants = window.variantsJSON;
    if (typeof variants == "undefined" || !variants) return;

    let currentVariant = null;
    let isGiftCard = false;

    for (const [option, variant] of Object.entries(window.variantsJSON)) {
      for (const [key, value] of Object.entries(variant)) {
        if (key == 'id' && parseInt(value) == parseInt(id)) {
          currentVariant = variant;
        }
      }
    }

    if (currentVariant) {
      if (currentVariant.sku.includes('RGGIFTCARD_')) {
        isGiftCard = true;
      }
    }

    let targets = document.querySelectorAll('.gift-card-field');
    if (isGiftCard) {
      targets.forEach((el) => {
        el.classList.remove('hidden');
        el.querySelector('input').removeAttribute('disabled');
      });
    } else {
      targets.forEach((el) => {
        el.classList.add('hidden');
        el.querySelector('input').setAttribute('disabled', 'true');
      });
    }

  }

  /**
   * Updates the special notice element for a specific product variant, activating the notice
   * that corresponds to the given product ID while deactivating all others.
   *
   * @param {string} id - The ID of the product variant for which the special notice should be updated.
   * @return {void} This method does not return any value.
   */
  updateVariantSpecialNotice(id) {

    document.querySelectorAll('.special-notice').forEach(function (item) {
      item.classList.remove('active');
    });

    if (document.querySelector('.special-notice[data-product-id="' + id + '"]') != null) {
      document.querySelector('.special-notice[data-product-id="' + id + '"]').classList.add('active');
    }
  }

  checkVariantAvailability() {
    let cont = document.querySelector('.product-form .option-selectors');
    if (!cont) return;
    let options = cont.querySelectorAll('.option-selector');
    let atcButton = document.querySelector('.product-form button[type="submit"]');
    let qtyTarget = document.querySelector('.quantity-wrapper input[name="quantity"]');
    let variants = window.variantsJSON;

    if(typeof variants == "undefined") return;
    //console.log('checkVariantAvailability')

    let selectedOption1 = null;
    let selectedOption2 = null;

    let selectedOption1El = options[0].querySelector('input:checked');
    if (selectedOption1El != null) selectedOption1 = selectedOption1El.value;
    let currentVariant = variants[selectedOption1];

    if (options.length === 2) {
      let selectedOption2El = options[1].querySelector('input:checked');
      if (selectedOption2El != null) selectedOption2 = selectedOption2El.value;
      currentVariant = variants[selectedOption1 + ' / ' + selectedOption2];
    }

    if (typeof currentVariant != "undefined" && typeof currentVariant.inventory_quantity != "undefined" && currentVariant && qtyTarget) {
      let maxQty = currentVariant.inventory_quantity;
      if (maxQty < 0) maxQty = 0;

      if(currentVariant.available && maxQty > 0) {
        qtyTarget.setAttribute('max', maxQty);
        if (parseInt(qtyTarget.value) > maxQty) qtyTarget.value = maxQty;
      }
      else {
        qtyTarget.removeAttribute('max');
      }
    }

    // If we only have the default variant just process that one
    if (!currentVariant && atcButton && variants.hasOwnProperty('Default Title')) {
      if (variants['Default Title'].available) {
        let atcText = atcButton.dataset.addToCartText;
        atcButton.toggleAttribute('disabled', false);
        atcButton.textContent = atcText;
      } else {
        atcButton.toggleAttribute('disabled', true);
        atcButton.textContent = 'Unavailable';
      }
      return;
    }

    let availableOptions1 = [];
    let availableOptions2 = [];

    let opt2El = document.querySelector('.option-selector[data-option-index="1"]');
    if (opt2El) {
      opt2El.querySelectorAll('input').forEach(el => {
        el.classList.toggle('oos-forced', true);
        el.classList.toggle('is-unavailable', true);
      })
    }

    // If we have multiple variants loop all variants and if they're not available make their buttons disabled
    for (const [key, value] of Object.entries(variants)) {
      let _key = key.split('/');
      let option1 = _key[0].replace(' ', '');
      let option2 = null;
      let option1El = options[0].querySelector('input[value="' + option1 + '"]');
      let option2El = null;

      if (typeof _key[1] != "undefined") {
        option2 = _key[1].replace(' ', '');
        option2El = options[1].querySelector('input[value="' + option2 + '"]');
      }

      if (value.available) {
        if (!availableOptions1.includes(option1)) {
          availableOptions1.push(option1);
        }
        if (!availableOptions2.includes(option1)) {
          availableOptions2.push(option1);
        }

        if (option1El) {
          option1El.classList.toggle('oos-forced', false);
          option1El.classList.toggle('is-unavailable', false);
        }
        if (option2El && option1 == selectedOption1) {
          option2El.classList.toggle('oos-forced', false);
          option2El.classList.toggle('is-unavailable', false);
        }
      } else {
        if (option1El && !availableOptions1.includes(option1)) {
          option1El.classList.toggle('oos-forced', true);
          option1El.classList.toggle('is-unavailable', true);
        }
        if (option2El && option1 == selectedOption1 && !availableOptions2.includes(option2)) {
          option2El.classList.toggle('oos-forced', true);
          option2El.classList.toggle('is-unavailable', true);
        }
      }

      if (atcButton && currentVariant) {
        let atcText = atcButton.dataset.addToCartText;
        if (!currentVariant.available) {
          atcButton.toggleAttribute('disabled', true);
          atcButton.classList.toggle('disabled', true);
          atcText = 'Unavailable';
        } else {
          atcButton.toggleAttribute('disabled', false);
          atcButton.classList.toggle('disabled', false);
        }
        atcButton.textContent = atcText;
      }
    }
  }

  handleStoreSelectorChange(childStoreId) {
    MultiStorefront.init(window.api_base_url, window.auth_token);
    let data = {
      'customer_id': window.customerId,
      'store_id': childStoreId,
    }
    MultiStorefront.post(`/customer/change-store`, data)
      .then(response => {
        if(typeof response.redirect_url != "undefined") {
          window.location.href = response.redirect_url;
        }
      });
  }

}

let multistore = new Multistore();
multistore.init();
